module.exports = __webpack_public_path__ + "static/media/IMG_0324.7ab02765.JPG";